module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_19.245f3eeb.jpeg";